<script setup>
import { Head, useForm } from '@inertiajs/inertia-vue3';
import { Mail, Lock } from 'lucide-vue-next';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/Components/ui/card';
import { Button } from '@/Components/ui/button';
import { Input } from '@/Components/ui/input';
import { Label } from '@/Components/ui/label';

const props = defineProps({
    email: String,
    token: String,
});

const form = useForm({
    token: props.token,
    email: props.email,
    password: '',
    password_confirmation: '',
});

const submit = () => {
    form.post(route('password.update'), {
        onFinish: () => form.reset('password', 'password_confirmation'),
    });
};
</script>

<template>
    <Head title="Đặt lại mật khẩu" />

    <div class="flex min-h-screen items-center justify-center bg-muted px-4 py-12">
        <Card class="w-full max-w-md">
            <CardHeader class="space-y-2 text-center">
                <CardTitle class="text-3xl">
                    <span class="font-bold">Đông Tây</span> ERP
                </CardTitle>
                <CardDescription>Đặt lại mật khẩu mới</CardDescription>
            </CardHeader>

            <CardContent>
                <JetValidationErrors class="mb-4" />

                <form class="space-y-4" @submit.prevent="submit">
                    <div class="space-y-2">
                        <Label for="email">Email</Label>
                        <div class="relative">
                            <Mail class="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                            <Input
                                id="email"
                                v-model="form.email"
                                type="email"
                                class="pl-10"
                                required
                                autofocus
                            />
                        </div>
                    </div>

                    <div class="space-y-2">
                        <Label for="password">Mật khẩu mới</Label>
                        <div class="relative">
                            <Lock class="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                            <Input
                                id="password"
                                v-model="form.password"
                                type="password"
                                class="pl-10"
                                placeholder="••••••••"
                                required
                                autocomplete="new-password"
                            />
                        </div>
                    </div>

                    <div class="space-y-2">
                        <Label for="password_confirmation">Xác nhận mật khẩu</Label>
                        <div class="relative">
                            <Lock class="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                            <Input
                                id="password_confirmation"
                                v-model="form.password_confirmation"
                                type="password"
                                class="pl-10"
                                placeholder="••••••••"
                                required
                                autocomplete="new-password"
                            />
                        </div>
                    </div>

                    <Button
                        type="submit"
                        class="w-full"
                        :class="{ 'opacity-50': form.processing }"
                        :disabled="form.processing"
                    >
                        Cập nhật mật khẩu
                    </Button>
                </form>
            </CardContent>
        </Card>
    </div>
</template>
